import { createStandardAction } from 'typesafe-actions'

const RESET_STATE = 'global/RESET_STATE'

export const resetState = createStandardAction(RESET_STATE)()



// WEBPACK FOOTER //
// ./src/state/actions.ts